import React from 'react';

export function StatCounter({ value, label, prefix = '', suffix = '', decimals = 0, duration = 1600, tone = 'blue', style = {} }) {
  const ref = React.useRef(null);
  const [display, setDisplay] = React.useState(0);
  const started = React.useRef(false);

  React.useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const run = () => {
      if (started.current) return;
      started.current = true;
      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) { setDisplay(value); return; }
      const t0 = performance.now();
      const tick = (t) => {
        const p = Math.min(1, (t - t0) / duration);
        setDisplay(value * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(tick);
        else setDisplay(value);
      };
      requestAnimationFrame(tick);
    };
    const io = new IntersectionObserver((entries) => { entries.forEach((e) => { if (e.isIntersecting) run(); }); }, { threshold: 0.4 });
    io.observe(el);
    return () => io.disconnect();
  }, [value, duration]);

  const num = display.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  const numberColor = tone === 'green' ? 'var(--energy)' : tone === 'white' ? '#fff' : 'var(--accent)';

  return (
    <div ref={ref} style={style}>
      <div style={{ fontFamily: 'var(--font-display)', fontWeight: 'var(--fw-extra)', fontSize: 'clamp(2.5rem, 1.5rem + 3vw, 4rem)', lineHeight: 1, letterSpacing: 'var(--ls-tight)', color: numberColor, fontVariantNumeric: 'tabular-nums', display: 'flex', alignItems: 'baseline' }}>
        {prefix}{num}{suffix}
      </div>
      <div style={{ marginTop: 'var(--space-3)', fontFamily: 'var(--font-ui)', fontSize: 'var(--fs-sm)', fontWeight: 'var(--fw-semibold)', letterSpacing: '0.02em', color: tone === 'white' ? 'var(--text-on-dark-muted)' : 'var(--text-muted)' }}>
        {label}
      </div>
    </div>
  );
}
